import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { pageMeta } from '../../utils/common';

const SEO = ({
  title,
  metaDescription,
  lang,
  metaImage,
  type,
  postData,
  keyword,
  cannonicalPath,
}) => (
  <Helmet
    title={`Komunal Group | ${title || ''}`}
    htmlAttributes={{
      lang: lang || 'id',
    }}
    meta={[
      {
        name: 'description',
        content: metaDescription || pageMeta.mainDesc,
      },
      {
        property: 'og:title',
        content: title || pageMeta.mainTitle,
      },
      {
        property: 'og:site_name',
        content: title,
      },
      {
        property: 'og:description',
        content: metaDescription,
      },
      {
        property: 'og:type',
        content: type,
      },
      {
        property: 'og:locale',
        content: lang,
      },
      // {
      //     property: 'og:url',
      //     content: url,
      // },
      {
        property: 'og:image',
        content: metaImage,
      },
      {
        property: 'og:image:alt',
        content: title,
      },
      {
        property: 'og:image',
        content: metaImage,
      },
      {
        name: 'twitter:card',
        content: 'summary',
      },
      {
        name: 'twitter:creator',
        content: 'komunal_id',
      },
      {
        name: 'twitter:image',
        content: metaImage,
      },
      {
        name: 'twitter:image:alt',
        content: title,
      },
      {
        name: 'twitter:title',
        content: title,
      },
      {
        property: 'twitter:site',
        content: title,
      },
      {
        name: 'twitter:description',
        content: metaDescription,
      },
      {
        name: 'keywords',
        content: keyword,
      },
    ]}
  >
    {postData ? (
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'Article',
          mainEntityOfPage: {
            '@type': 'WebPage',
            '@id': 'https://google.com/article',
          },
          headline: postData.title,
          image: [metaImage],
          datePublished: postData.datePublished,
          dateModified: postData.datePublished,
          author: {
            '@type': 'Person',
            name:
              postData.authors
                && postData.authors.length > 0
                && postData.authors[0]
                ? postData.authors[0].name
                : null,
          },
          publisher: {
            '@type': 'Organization',
            name: 'Komunal Group',
            logo: {
              '@type': 'ImageObject',
              // eslint-disable-next-line global-require
              url: require('../../images/komunal-logo-512.jpg'),
            },
          },
        })}
      </script>
    ) : null}
    if(cannonicalPath) <link rel="canonical" href={`https://komunalgroup.com/${cannonicalPath}`} />
  </Helmet>
);

export default SEO;
SEO.propTypes = {
  title: PropTypes.string.isRequired,
  metaDescription: PropTypes.string.isRequired,
  lang: PropTypes.string,
  metaImage: PropTypes.object,
  keyword: PropTypes.array,
  postData: PropTypes.string,
  type: PropTypes.string,
  cannonicalPath: PropTypes.string,
};

SEO.defaultProps = {
  keyword: 'komunal, deposito bpr, BPR, komunal bpr, komunal deposito, komunal group, p2p lending, neo rural bank, rural bank',
  postData: '',
  type: 'blog',
  metaImage: null,
  lang: 'id',
  cannonicalPath: '',
};
